// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"bebaa781adb898d1","5285":"e234fbb0b8bc37cf"}[chunkId] + ".css";
};